
<template>
  <div>
    <el-select
      :disabled="disable"
      v-model="provience"
      placeholder="请选择省份"
      size="small"
      @focus="onFocus"
      @change="onChangeProvience"
      style="margin-right:10px;">
      <el-option
        v-for="item in provienceOptions"
        :key="item.id"
        :label="item.areaName"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select
      :disabled="disable"
      v-model="city"
      placeholder="请选择市"
      size="small"
      @focus="onFocus"
      @change="onChangeCity"
      style="margin-right:10px;">
      <el-option
        v-for="item in cityOptions"
        :key="'2'+item.id"
        :label="item.areaName"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select
      :disabled="disable"
      v-model="area"
      placeholder="请选择县区"
      size="small"
      @focus="onFocus"
      @change="onChangeArea">
      <el-option
        v-for="item in areaOptions"
        :key="'3'+item.id"
        :label="item.areaName"
        :value="item.id">
      </el-option>
    </el-select>
    <span style="margin-left:8px;font-size:12px;color:rgba(0,0,0,0.25);" v-if="!!tips">{{tips}}</span>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: {
    tips: {
      type: String,
      default: ''
    },
    detail: {
      type: Object
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provienceOptions: [],
      cityOptions: [],
      areaOptions: [],
      provience: '',
      city: '',
      area: '',
      current: '',
      areaIds: []
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userSelfAreaId', 'globaleSelfAreaId'])
  },
  created() {
    const vm = this
    vm.initProvience()
  },
  methods: {
    preInitAddress() {
      const vm = this
      vm.$nextTick(() => {
        const params = {
          selfAreaId: vm.selfAreaId
        }
        if (vm.detail && vm.detail.areaId) { // 地址回填的逻辑
          params.areaId = vm.detail.areaId
        } else if (vm.userSelfAreaId) {
          params.areaId = vm.userSelfAreaId
        }
        if (params.areaId) {
          Api.getUserArea(params)
            .then(res => {
              if (res.code === 200) {
                vm.areaIds = []
                if (res.data.province && res.data.province.areaName) {
                  vm.areaIds.push({
                    key: 'province',
                    areaName: res.data.province.areaName,
                    id: res.data.province.id
                  })
                }
                if (res.data.city && res.data.city.areaName) {
                  vm.areaIds.push({
                    key: 'city',
                    areaName: res.data.city.areaName,
                    id: res.data.city.id
                  })
                }
                if (res.data.region && res.data.region.areaName) {
                  vm.areaIds.push({
                    key: 'region',
                    areaName: res.data.region.areaName,
                    id: res.data.region.id
                  })
                }
                if (vm.areaIds && vm.areaIds.length) {
                  vm.initAddress()
                }
              }
            })
        }
      })
    },
    initAddress() {
      const vm = this
      vm.areaIds.forEach(address => {
        if (address && address.key === 'province') {
          vm.$nextTick(() => {
            vm.provience = address.id
            vm.initCity.call(this, address.id)
          })
        }
        if (address && address.key === 'city') {
          vm.$nextTick(() => {
            vm.city = address.id
            vm.initArea.call(this, address.id)
          })
        }
        if (address && address.key === 'region') {
          vm.area = address.id
        }
      })
      vm.$emit('input', vm.areaIds[vm.areaIds.length - 1].id)
    },
    onFocus() {
      console.log('请求数据')
    },
    onChangeProvience(item) {
      this.current = item
      const area = {
        provience: this.provience,
        city: '',
        area: ''
      }
      this.$emit('input', item, area)
      this.city = ''
      this.area = ''
      this.initCity(item)
    },
    onChangeCity(item) {
      this.current = item
      const area = {
        provience: this.provience,
        city: this.city,
        area: ''
      }
      this.$emit('input', item, area)
      this.area = ''
      this.initArea(item)
    },
    onChangeArea(item) {
      const area = {
        provience: this.provience,
        city: this.city,
        area: this.area
      }
      this.$emit('input', item, area)
    },
    initProvience() {
      const params = {
        selfAreaId: this.selfAreaId,
        areaId: this.selfAreaId
      }
      Api.getUserArea2(params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            this.provienceOptions = res.data
            this.preInitAddress()
          }
        })
    },
    initCity(id) {
      if (Number(this.globaleSelfAreaId)) {
        this.cityOptions = this.filterAddress(this.provienceOptions, id, 1)
      } else {
        const params = {
          areaId: id || this.current,
          selfAreaId: this.selfAreaId
        }
        Api.getArea(params)
          .then(res => {
            console.log(res)
            if (res.code === 200) {
              if (this.userSelfAreaId && this.areaIds && this.areaIds.length >= 2) {
                const areaRealId = this.areaIds[1].id
                this.cityOptions = res.data.filter(city => city.id === areaRealId)
              } else {
                this.cityOptions = res.data
              }
            }
          })
      }
    },
    filterAddress(adds, id, level) {
      console.log('filterAddress', adds, id)
      const address = JSON.parse(JSON.stringify(adds))
      if (!address || !address.length) {
        return address
      }
      if (level === 1) {
        return address.find(it => it.id === id).child
      } else if (level === 2) {
        for (const it of address) {
          for (const add of it.child) {
            if (add && add.id === id) {
              for (let i = 0, l = add.child.length; i < l; i++) {
                const item = add.child[i]
                if (item && item.aggregation && item.child) {
                  item.child.forEach(it => {
                    add.child.push(it)
                  })
                }
              }
              return add.child
            }
          }
        }
      }
    },
    initArea(id) {
      if (Number(this.globaleSelfAreaId)) {
        this.areaOptions = this.filterAddress(this.provienceOptions, id, 2)
      } else if (id && this.areaIds && this.areaIds.length < 3) {
        const pId = (this.areaIds[0] && this.areaIds[0].id) || this.provience
        const cId = id || this.city
        const aId = undefined
        const cpProvienceOptions = JSON.parse(JSON.stringify(this.provienceOptions))
        const ps = cpProvienceOptions.find(item => item.id === pId)
        const cs = ps && ps.child && ps.child.find(item => item.id === cId)
        for (let i = 0, l = cs.child.length; i < l; i++) {
          const item = cs.child[i]
          if (item && item.aggregation && item.child) {
            item.child.forEach(it => {
              cs.child.push(it)
            })
          }
        }
        const as = cs && cs.child && cs.child.find(item => item.id === aId)
        if (this.userSelfAreaId && this.areaIds && this.areaIds.length >= 3) {
          if (as.aggregation) {
            this.areaOptions = cs.child
          } else {
            this.areaOptions = [as]
          }
        } else {
          this.areaOptions = cs.child
        }
      } else {
        const pId = this.areaIds[0] && this.areaIds[0].id
        const cId = this.areaIds[1] && this.areaIds[1].id
        const aId = this.areaIds[2] && this.areaIds[2].id
        const cpProvienceOptions = JSON.parse(JSON.stringify(this.provienceOptions))
        const ps = cpProvienceOptions.find(item => item.id === pId)
        const cs = ps && ps.child && ps.child.find(item => item.id === cId)
        for (let i = 0, l = cs.child.length; i < l; i++) {
          const item = cs.child[i]
          if (item && item.aggregation && item.child) {
            item.child.forEach(it => {
              cs.child.push(it)
            })
          }
        }
        const as = cs && cs.child && cs.child.find(item => item.id === aId)
        if (this.userSelfAreaId && this.areaIds && this.areaIds.length >= 3) {
          if (as.aggregation) {
            this.areaOptions = cs.child
          } else {
            this.areaOptions = [as]
          }
        } else {
          this.areaOptions = cs.child
        }
        // console.log('省', ps, '市', cs, '区', as)
        // const params = {
        //   areaId: id || this.current,
        //   selfAreaId: this.selfAreaId
        // }
        // Api.getArea(params)
        //   .then(res => {
        //     // console.log(res)
        //     if (res.code === 200) {
        //       if (this.userSelfAreaId && this.areaIds && this.areaIds.length >= 3) {
        //         const areaRealId = this.areaIds[2].id
        //         this.areaOptions = res.data.filter(area => area.id === areaRealId)
        //       } else {
        //         this.areaOptions = res.data
        //       }
        //     }
        //   })
      }
    }
  }
}
</script>
